import { Link } from 'react-router-dom';
import { FAQS } from '@/mocks/faqs';
import SectionHeading from '@/components/feature/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';

export default function HomeFaq() {
  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="大家最常问的几件事"
              description="如果你关心的是材料来源、隐私边界或者怎么投稿，这里大概都有答案。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <FaqAccordion items={FAQS.slice(0, 5)} />
          </div>
        </div>
      </div>
    </section>
  );
}